import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.white,
  secondaryBgColor: colors.white,
  textColorDark: colors.smoke,
  textColorLight: colors.white
};
export default imageSlider;